import { render, staticRenderFns } from "./References.vue?vue&type=template&id=26254251&scoped=true&lang=pug"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"
import style0 from "./References.vue?vue&type=style&index=0&id=26254251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26254251",
  null
  
)

export default component.exports